// export const config = {
//     baseURLApi: 'https://api.spaceagelabs.com.sg/v2'
// }
export const config = {
    baseURLApi: process.env.REACT_APP_API_ENDPOINT
}